
import { axiosInstance } from "../../utility/apiInstance";
import { ContactPayload } from "./contact.types";

export const fetchContacts = async (search = "") => {
  const res = await axiosInstance.get(`/api/v1/contact?search=${encodeURIComponent(search)}`);
  return res?.data?.data || [];
};

export const createContact = (payload: ContactPayload) =>
  axiosInstance.post("/api/v1/contact/add-contact", payload);

export const updateContact = (id: string, payload: ContactPayload) =>
  axiosInstance.patch(`api/v1/contact/update-contact/${id}`, payload);

// "Delete" is a status toggle
export const toggleContactStatus = (id: string, isActive: boolean) =>
  axiosInstance.post(`api/v1/contact/delete-contact/${id}`, { isActive });

export const fetchFlags = async () => {
  const { data } = await axiosInstance.get("/api/v1/flags");
  const list = Array.isArray(data) ? data : data?.data || [];
  return list
    .filter((flag: any) => flag.status === "Active")
    .map((flag: any) => ({ ...flag, _id: flag._id || flag.id }));
};

export const fetchOrganizations = async (query = "") => {
  const { data } = await axiosInstance.get(
    `/api/v1/master-contact-organization?search=${encodeURIComponent(query)}`
  );
  return data?.data || [];
};

export const createOrganization = async (name: string) => {
  const { data } = await axiosInstance.post("/api/v1/master-contact-organization", { name });
  return data?.data;
};

export const fetchCountryCodes = async () => {
  const res = await axiosInstance.get("/api/v1/country/counry-code");
  if (res.data?.success) {
    return (res.data.data || []).map((item: any) => ({
      ...item,
      label: item?.name,
      value: item?.calling_code,
    }));
  }
  return [];
};